import { useState } from 'react';
import { useFirmContext } from '../../../../providers/FirmProvider';
import { useFirmSubscription } from '../../../../queries/use-firm-subscription';
import { AlertV2, Spinner } from '@cimplico/components';
import ScheduledUpdates from './ScheduledUpdates';
import Plan from './Plan';
import Billing from './Billing';
import Quota from './Quota';
import EditPlan from './EditPlan';
import ActiveEntities from './active-entities/ActiveEntities';

function FirmBillingSubscriptionContainer(): JSX.Element {
    const { id } = useFirmContext();
    const [editing, setEditing] = useState<'plan' | 'entities'>();
    const subscriptionQuery = useFirmSubscription(id);

    if (subscriptionQuery.isLoading) {
        return (
            <div className="mx-auto w-fit pt-8">
                <Spinner />
            </div>
        );
    }

    if (subscriptionQuery.isError || !subscriptionQuery.isSuccess) {
        return <>Error</>;
    }

    const subscription = subscriptionQuery.data.subscription;

    return (
        <div className="grid gap-y-4">
            {subscription.isBespokeAgreement && (
                <AlertV2
                    type="info"
                    title="This subscription is a bespoke agreement and cannot be modified."
                    description="If you wish to make changes, please contact support."
                />
            )}
            {editing === 'plan' && <EditPlan onClose={(): void => setEditing(undefined)} subscription={subscription} />}
            {!editing && (
                <>
                    <ScheduledUpdates subscription={subscription} />
                    <Plan subscription={subscription} onManage={(): void => setEditing('plan')} />
                    <ActiveEntities subscription={subscription} />
                    <Quota subscription={subscription} />
                    <Billing />
                </>
            )}
        </div>
    );
}

export default FirmBillingSubscriptionContainer;
